<template>
  <div class="email-app-details bg-white">

    <div class="email-detail-header">
      <div class="email-header-left d-flex align-items-center">
        <span class="go-back mr-1">
          <feather-icon
            :icon="$store.state.appConfig.isRTL ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
            size="20"
            class="align-bottom"
            @click="$emit('cancel-nova-visita')"
          />
        </span>
        <h4
          v-if="visitaEditMode"
          class="email-subject mb-0"
        >
          {{ $t('Editar visita externa') }}
        </h4>
        <h4
          v-else
          class="email-subject mb-0"
        >
          {{ $t('Nova visita externa') }}
        </h4>
      </div>
    </div>

    <vue-perfect-scrollbar
      class="email-scroll-area scroll-area pr-0 pl-0"
      :settings="configSettingsScroll"
    >

      <b-container
        fluid
        class="p-2"
      >
        <validation-observer
          ref="formNovaVisitaLeadExterna"
          #default="{}"
        >
          <b-row
            v-if="arrayAngariacao.pid == null"
            class="mb-2"
          >
            <b-col md="6">
              <b-button
                variant="outline-primary"
                @click.stop.prevent="openModalAngariacao"
              >
                <span class="align-middle">{{ $t('Adicionar angariação') }}</span>
              </b-button>
            </b-col>
          </b-row>
          <b-row
            v-if="arrayAngariacao.pid != null"
            class="mb-2"
          >
            <b-col
              md="6"
              class="d-flex justify-content-between flex-column"
            >
              <!-- User Avatar & Action Buttons -->
              <div class="d-flex justify-content-start">
                <b-avatar
                  :src="arrayAngariacao.imagem + '?v=' + new Date().getTime()"
                  size="110px"
                  rounded
                />
                <div class="d-flex flex-column ml-1">
                  <div class="mb-1">
                    <h5 class="mb-0">
                      {{ arrayAngariacao.pid }}
                    </h5>
                    <span class="card-text"> {{ arrayAngariacao.tipologia }} </span><br>
                    <span class="card-text"> {{ arrayAngariacao.nomeConsultor }} </span>
                  </div>
                  <div class="d-flex flex-wrap">
                    <b-button
                      variant="outline-primary"
                      @click.stop.prevent="openModalAngariacao"
                    >
                      {{ $t('Alterar') }}
                    </b-button>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="arrayConsultoresTeam.length > 0">
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                rules="required"
                :name="$t('Tipo')"
              >
                <b-form-group
                  :label="$t('Escolha um consultor')"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <v-select
                    id="fSW070_flttipo"
                    v-model="form_data.sw070s02"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="arrayConsultoresTeam"
                    label="nome"
                    item-text="nome"
                    item-value="id"
                    :class="errors.length > 0 ? 'is-invalid':null"
                    @input="setListLeads"
                  >
                    <template #option="{ nome }">
                      {{ nome }}
                    </template>
                    <div slot="no-options">
                      {{ $t('Sem resultados') }}
                    </div>
                  </v-select>

                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  :label="$t('Rede imobiliária')"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <v-select
                    id="fSW070_flt128"
                    v-model="form_data.sw070s21"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="arraySW128"
                    class="mb-1"
                    label="sw128s02"
                    item-text="sw128s02"
                    item-value="sw128s01"
                    @input="getAgenciasList"
                  >
                    <template #option="{ sw128s02 }">
                      {{ sw128s02 }}
                    </template>
                    <div slot="no-options">
                      {{ $t('Sem resultados') }}
                    </div>
                  </v-select>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  :label="$t('Agência')"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <v-select
                    id="fSW070_flt172"
                    v-model="form_data.sw070s41"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="arraySW172"
                    class="mb-50"
                    :loading="loadingAgenciasFlag"
                    label="designacao_comercial"
                    item-text="designacao_comercial"
                    item-value="id"
                    @input="getListAgentes"
                  >
                    <template #option="{ designacao_comercial }">
                      {{ designacao_comercial }}
                    </template>
                    <div slot="no-options">
                      {{ $t('Escolha uma rede imobiliária') }}
                    </div>
                  </v-select>
                  <a
                    class="company-name text-primary"
                    @click.stop.prevent="$emit('form-nova-agencia')"
                  > Não encontra? </a>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  :label="$t('Agente')"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <v-select
                    id="fSW070_flt025"
                    v-model="form_data.sw070s46"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="arraySW025"
                    :loading="loadingAgentesFlag"
                    class="mb-50"
                    label="nome"
                    item-text="nome"
                    item-value="id_encode"
                  >
                    <template #option="{ nome }">
                      {{ nome }}
                    </template>
                    <div
                      v-if="form_data.sw070s41 !== null && form_data.sw070s41 !== undefined"
                      slot="no-options"
                    >
                      {{ $t('Sem resultados') }}
                    </div>
                    <div
                      v-if="form_data.sw070s41 === null || form_data.sw070s41 === undefined"
                      slot="no-options"
                    >
                      {{ $t('Escolha uma agência') }}
                    </div>
                  </v-select>
                  <a
                    class="company-name text-primary"
                    @click.stop.prevent="$emit('form-novo-agente')"
                  > Não encontra? </a>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                rules=""
              >
                <b-form-group
                  :label="$t('Nome do cliente')"
                >
                  <b-form-input
                    v-model="form_data.sw070s26"
                    :class="{'form-control' : true, 'is-invalid': errors.length > 0 }"
                    placeholder=""
                    autocomplete="off"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                rules="email"
              >
                <b-form-group
                  :label="$t('Email do cliente')"
                >
                  <b-form-input
                    v-model="form_data.sw070s27"
                    placeholder=""
                    autocomplete="off"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                :rules="{numberVueTelInput: numberPhoneValidate }"
                mode="eager"
              >
                <b-form-group
                  :label="$t('Telefone do cliente')"
                >
                  <vue-tel-input
                    ref="phoneLeadExterna"
                    v-model="form_data.sw070s28"
                    class="form-control"
                    inputmode="tel"
                    :mode="configPhone.mode"
                    :valid-characters-only="configPhone.validCharactersOnly"
                    :auto-format="configPhone.autoFormat"
                    :default-country="configPhone.defaultCountry"
                    :auto-default-country="configPhone.autoDefaultCountry"
                    :input-options="configPhone.inputOptions"
                    :dropdown-options="configPhone.dropdownOptions"
                    :class="errors.length > 0 ? 'is-invalid':null"
                    @input="checkValidateNumberPhone"
                    @open="onDropdownOpenTelInput"
                    @keydown.native.tab.prevent="$event.target.blur()"
                    @blur.native.capture.prevent="inputValidateNumberPhone($refs.phoneLeadExterna)"
                  >
                    <template slot="arrow-icon">
                      {{ '\xa0' }}
                    </template>
                    <template slot="icon-right">
                      {{ '\xa0' }}
                    </template>
                  </vue-tel-input>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  :label="$t('Data do evento')"
                >
                  <date-picker
                    v-model="form_data.sw070s10"
                    value-type="format"
                    :input-class="{'form-control' : true, 'is-invalid': errors.length > 0 }"
                    type="date"
                    :editable="false"
                    :clearable="true"
                    :lang="langCalendar"
                    :append-to-body="true"
                    prefix-class="sw"
                    @change="checkConcluirAction"
                  >
                    <template #icon-clear>
                      <v-select-deselect />
                    </template>
                  </date-picker>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                rules="required"
              >
                <b-form-group
                  :label="$t('Hora do evento')"
                >
                  <b-form-timepicker
                    v-model="form_data.sw070s10_time"
                    placeholder="00:00"
                    hide-header
                    now-button
                    :label-close-button="$t('Fechar')"
                    :label-now-button="$t('Hora atual')"
                    :class="errors.length > 0 ? 'is-invalid':null"
                    @input="checkConcluirAction"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                :label="$t('Observação')"
              >
                <b-form-textarea
                  v-model="form_data.sw070s12"
                  placeholder=""
                  rows="3"
                />
              </b-form-group>
            </b-col>
          </b-row>

        </validation-observer>
      </b-container>
      <div
        class="d-flex p-1 justify-content-center  d-block d-sm-none"
      >
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          class="mr-1"
          @click.stop.prevent="$emit('cancel-nova-visita')"
        >
          {{ $t('Cancelar') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-1"
          type="submit"
          @click.stop.prevent="$emit('save-nova-visita')"
        >
          {{ $t('Guardar') }}
        </b-button>
        <b-button
          v-if="flagShowConcluir"
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="warning"
          @click.stop.prevent="$emit('concluir-nova-visita')"
        >
          {{ $t('Concluir') }}
        </b-button>
      </div>
      <b-overlay
        :show="$store.getters['crm_visitas_listview/loadingListview']"
        no-wrap
      />

    </vue-perfect-scrollbar>
  </div>

</template>

<script>
import {
  BRow, BCol, BButton, BFormInput, VBTooltip, BFormGroup, BContainer, BOverlay, BFormTimepicker, BFormTextarea, BAvatar,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Dialog } from '@capacitor/dialog'
import useCapacitor from '@core-custom/utils/capacitor'
import { sizeIconsAction } from '@core-custom/mixins/geral'
import VuePerfectScrollbar from '@/views/modules/components/vue-perfect-scrollbar.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'
import { mapGetters } from 'vuex'
import { numberVueTelInput } from '@validations-custom'
import { configPhone } from '@core-custom/utils/phone'
// import { format, isAfter, parseISO } from 'date-fns'
import { configSettingsScroll } from '@core-custom/utils/ui'
import
{
  isPossiblePhoneNumber,
  validatePhoneNumberLength,
  parsePhoneNumber,
} from 'libphonenumber-js/max'

const oVueTelInput = () => Promise.all([
  import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
  import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css'),
]).then(([{ VueTelInput }]) => VueTelInput)

const oDatepicker = () => Promise.all([
  import(/* webpackChunkName: "chunk-vue2-datepicker" */ 'vue2-datepicker'),
  import(/* webpackChunkName: "chunk-vue2-datepicker" */ '@/assets/scss/datepicker.scss'),
]).then(([DatePicker]) => DatePicker)

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BAvatar,
    BFormGroup,
    BContainer,
    VuePerfectScrollbar,
    BOverlay,
    BFormTimepicker,
    ValidationProvider,
    ValidationObserver,
    vSelectDeselect: vSelect.components.Deselect,
    vSelect,
    DatePicker: oDatepicker,
    VueTelInput: oVueTelInput,
    BFormTextarea,
    BFormInput,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [sizeIconsAction],
  props: {
    openModalAngariacao: {
      type: Function,
      required: true,
    },
    visitaEditMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      numberVueTelInput,
      configPhone,
      search: [],
      langCalendar: {},
      pidAngariacao: null,
      loadingAgenciasFlag: false,
      loadingAgentesFlag: false,
    }
  },
  computed: {
    ...mapGetters('crm_visitas_form', ['arrayAngariacao', 'form_data', 'arraySW128', 'arraySW172', 'arraySW025', 'arrayConsultoresTeam', 'flagShowConcluir']),
    numberPhoneValidate() {
      try {
        if (this.form_data.sw070s28) {
          return this.$refs.phoneLeadExterna.phoneObject
        }
      } catch (err) {
        //
      }

      return null
    },
  },
  watch: {},
  async mounted() {
    await this.importLocale(this.$i18n.locale).then(res => {
      this.langCalendar = res.default
    })
  },
  methods: {
    async setListLeads() {
      await this.$store.dispatch('crm_visitas_form/setListLeads').catch(error => {
        this.showMsgErrorRequest(error)
      })
    },
    loadDataFormPhone() {
      try {
        if (('sw070s28' in this.form_data)) {
          this.telefone = this.form_data.sw070s28
        }
      } catch (err) {
        //
      }
    },
    onDropdownOpenTelInput() {
      this.$nextTick(() => {
        const widthElInputTel = this.$refs.phoneLeadExterna.$el.offsetWidth
        const el = this.$refs.phoneLeadExterna.$refs.list
        el.querySelector('.vti__search_box').placeholder = this.$t('Digite o nome')
        el.querySelector('.vti__search_box').addEventListener('keydown', evt => {
          const charCode = (evt.which) ? evt.which : window.event.keyCode

          if (charCode === 187) {
            evt.preventDefault()
          }
        })

        el.style.width = `${widthElInputTel}px`
      })
    },
    checkValidateNumberPhone($event, phoneObject) {
      this.configPhone.inputOptions.maxlength = 25
      try {
        const phoneNumber = parsePhoneNumber($event, phoneObject?.countryCode || '')
        if (phoneNumber) {
          const sIsPossiblePhoneNumber = isPossiblePhoneNumber(`${$event}0`) // Insert +1 character to simulate
          const sValidatePhoneNumberLength = validatePhoneNumberLength(`${$event}0`) // Insert +1 character to simulate

          if (sValidatePhoneNumberLength === 'TOO_LONG') {
            if (sIsPossiblePhoneNumber === false) {
              this.configPhone.inputOptions.maxlength = $event.length ?? 0
            }
          }
        }
      } catch (error) {
        //
      }
    },
    inputValidateNumberPhone(obj) {
      if (obj?.phoneObject?.number !== undefined && obj.phoneObject.number !== '') {
        try {
          const phoneNumber = parsePhoneNumber(obj.phoneObject.number, obj.phoneObject?.countryCode || '')
          if (phoneNumber) {
            const sIsValidPhoneNumber = phoneNumber.isValid()
            if (sIsValidPhoneNumber === false) {
              this.$nextTick(() => {
                this.$store.dispatch('crm_visitas_form/updateFieldValue', { field: 'sw070s28', value: '' })
              })
            } else {
              this.$nextTick(() => {
                this.$store.dispatch('crm_visitas_form/updateFieldValue', {
                  field: 'sw070s28',
                  value: phoneNumber.formatInternational(),
                })
              })
            }
          }
        } catch (error) {
          //
        }
      } else {
        this.$nextTick(() => {
          this.$store.dispatch('crm_visitas_form/updateFieldValue', { field: 'sw070s28', value: '' })
        })
      }
    },
    async importLocale(lang) {
      return import(`vue2-datepicker/locale/${lang}`)
    },
    async showMsgErrorRequest(error) {
      if (useCapacitor.isNative() === true) {
        Dialog.alert({
          title: this.$t('Alerta'),
          message: error.message,
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('Alerta'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error.message,
          },
        })
      }
    },
    async showMsgSuccessRequest(info) {
      if (info.message) {
        await this.$swal({
          title: '',
          text: info.message,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-outline-primary',
          },
          buttonsStyling: false,
        })
      }
    },
    listviewFilterOrderBy(field) {
      this.$store.dispatch('share/listviewFilterOrderBy', field).catch(error => {
        this.showMsgErrorRequest(error)
      })
    },
    listviewIconOrderBy(filterField, renderClass) {
      let returnIcon = 'ArrowUpIcon'
      let returnClass = 'opacity-0'

      if (this.listviewOrderBy.column === filterField) {
        if (this.listviewOrderBy.sort === 'asc') {
          returnClass = 'opacity-1'
          returnIcon = 'ArrowUpIcon'
        } else {
          returnClass = 'opacity-1'
          returnIcon = 'ArrowDownIcon'
        }
      }

      if (renderClass === true) {
        return returnClass
      }

      return returnIcon
    },
    async getAgenciasList() {
      this.loadingAgenciasFlag = true
      await this.$store.dispatch('crm_visitas_form/loadArray172').catch(error => {
        this.showMsgErrorRequest(error)
      })
      this.loadingAgenciasFlag = false
    },
    async getListAgentes() {
      this.loadingAgentesFlag = true
      await this.$store.dispatch('crm_visitas_form/loadArray025').catch(error => {
        this.showMsgErrorRequest(error)
      })
      this.loadingAgentesFlag = false
    },
    checkConcluirAction() {
      // if (this.form_data.sw070s10 !== undefined && this.form_data.sw070s10 !== null && this.form_data.sw070s10_time !== undefined && this.form_data.sw070s10_time !== null) {
      //   const dateedit = `${this.form_data.sw070s10} ${this.form_data.sw070s10_time}`

      //   let dataAtual = new Date().toISOString()
      //   dataAtual = dataAtual.replace('T', ' ', dataAtual)
      //   dataAtual = dataAtual.substring(0, 19)
      //   dataAtual = format(parseISO(dataAtual), 'yyyy-MM-dd HH:mm')
      //   const dataEvento = format(parseISO(dateedit), 'yyyy-MM-dd HH:mm')
      //   const result = isAfter(parseISO(dataAtual), parseISO(dataEvento))

      //   this.$store.dispatch('crm_visitas_form/setFlagShowConcluir', result).catch(error => {
      //     this.showMsgErrorRequest(error)
      //   })
      // }
    },
  },
  setup() {
    const telefone = ref(null)

    return {
      avatarText,
      telefone,
      configSettingsScroll,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>
<style lang="scss" scoped>
.email-app-details .email-scroll-area {
  height: calc(100% - calc(4.9rem)) !important;
}

.email-app-details {
  width: 100% !important;
  z-index: 3 !important;
}

.vti__search_box {
  width: 100% !important;
}
</style>
